export default __webpack_public_path__ + "static/media/photography-equip.38a3f571.webp";